import CustomAddChipSearch from '../../../../../../components/CustomAddChipSearch';
import { USER_TYPE_MODEL } from '../../../../../../enums/userTypeEnum';
import {getDaysOfCurrentMonth, userListToLabelEmailPhoneValue} from '../../../../../../Apis/functions';
import { PersonChipBlack } from '../../../../../../components/buttons/IconButtons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {CustomSelect} from '../../../../../../components/CustomSelect';
import {EmailFrequency} from '../../../../../../enums/EmailFrecuency';
import CustomTimePicker from '../../../../../../components/CustomTimePicker';
import {CustomTextField} from '../../../../../../components/CustomTextField';
import {getDaysList} from '../../../../../../utils/DaysofWeek';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param user
 * @param setUser
 */
const Receivers = (
    {
        user,
        setUser,
        disabled = false
    }
) => {

    const { t } = useTranslation();

    return (
        <>
            <p className="fs-14px font-color-shades-950 ibl-font-w-600 pb-4">{t("receivers")}</p>

            <div className="row px-0">
                <div className="col-12 col-sm-3 pb-4 pb-sm-0 fs-12px font-color-shades-950 ibl-font-w-400">
                    {t("select_the_employees_who_should_receive_the_scheduled_email_reports")}
                </div>
                <div className="col-12 col-sm-9 px-0">
                    <CustomAddChipSearch
                        id="slt_aes_search_users"
                        selectedList={user}
                        setSelectedList={setUser}
                        userTypeIdsSearch={[
                            USER_TYPE_MODEL.EMPLOYEE
                        ]}
                        disabled={disabled}
                        label="name"
                        required={false}
                        reset={false}
                        hideButton={disabled}
                        keyId={"userId"}
                        showSubSection={true}
                        sanitizeDataList={userListToLabelEmailPhoneValue}
                        Icon={PersonChipBlack}
                    />
                </div>
            </div>
        </>
    );
}

export default Receivers
